<template>
<div>
	<!-- h5版本 -->
	<div class="power-wrap-mobile" id="power">
		<div class="title">{{ title }}</div>
		<div class="btn-info" data-wow-delay="100ms">
			<div class="btn-con">
				<div v-for="(item, index) in btnList" @click="activefuns(index)" :class="['item', activeIndex == index ? 'active' : '']" :key="index">
					<div class="text">{{item.name}}</div>
				</div>
			</div>
		</div>
		<div v-for="(item, index) in powerList" :key="index" :class="['power-item', 'fadeIn', activeIndex == index ? 'power-item-active' : '']">
			<img class="img" :src="item.imgSrc" />
			<div class="des" v-for="(subitem, subindex) in item.desList" :key="subindex">
				<div class="title">{{ subitem.title }}</div>
				<div class="text">{{ subitem.des }}</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
export default {
  props: {
		title: String,
		powerList: Array,
		btnList: Array,
  },
  data() {
    return {
			timer: '',
			activeIndex: 0,
    }
  },
	created() {
	},
  methods: {
		activefuns(index) {
			// if (window.innerWidth < 1024) return
			// clearInterval(this.timer)
			this.activeIndex = index
			// this.timer = setInterval(() => {
			// 	this.activeIndex++
			// 	if (this.activeIndex >= 5) {
			// 		this.activeIndex = 0
			// 	}
			// }, 6000)
		},
		activefun() {
			if (window.innerWidth < 1024) return
			setTimeout(() => {
				this.activeIndex++
				if (this.activeIndex >= 5) {
					this.activeIndex = 0
				}
			})
			this.timer = setInterval(() => {
				this.activeIndex++
				if (this.activeIndex >= 5) {
					this.activeIndex = 0
				}
			}, 5000)
		},
},
  computed: {},
}
</script>

<style lang="less" scoped>
	.power-wrap {
    display: none;
	}
	.power-wrap-mobile {
		background-color: #FAFAFC;
		padding-top: 1.0667rem;
		padding-bottom: 1.0667rem;
		.title {
			font-size: .5867rem;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #000000;
			line-height: .5867rem;
			text-align: center;
		}
		.btn-info {
			margin-top: 1.0667rem;
			padding-left: .4rem;
			border-bottom: 1px solid #EEEEEE;
			width: 100%;
			overflow: auto;
			white-space: nowrap;
			.btn-con {
				width: auto;
			}
			.item {
				display: inline-block;
				vertical-align: middle;
				font-size: .48rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #202640;
				line-height: .6667rem;
				margin-right: .8rem;
				padding-bottom: .2667rem;
				
			}
			.active {
				position: relative;
				&::after {
					content: '';
					position: absolute;
					width: 1.7067rem;
					height: .08rem;
					background: #E61717;
					left: 0;
					bottom: 0;
				}
			}
		}
		.power-item {
			display: none;
			padding: .3733rem .4rem 0;
			.img {
				width: 100%;
				height: 5.6533rem;
			}
			.des {
				.title {
					margin-top: .8rem;
					font-size: .48rem;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #202640;
					line-height: .6667rem;
					text-align: left;
				}
				.text {
					font-size: .3733rem;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #202640;
					line-height: .64rem;
					margin-top: .2667rem;
				}
			}
		}
		.power-item-active {
			display: block;
		}
	}
.fadeIn {
	animation-delay: 100ms;
  animation-name: fadeIn;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

</style>